module.exports = __webpack_public_path__ + "static/media/DSC_1035.ab0ba5ee.jpg";